import React from 'react';
import './TokenizationSteps.css';

const TokenizationSteps = ({ onLearnMore }) => {
  const steps = [
    {
      id: 1,
      title: 'Verify & Connect',
      description: 'Complete KYC/AML and connect a supported wallet for whitelisting'
    },
    {
      id: 2,
      title: 'Buy Tokens',
      description: 'Buy tokens representing your ownership in the real estate fund'
    },
    {
      id: 3,
      title: 'Earn Yield',
      description: 'Receive monthly rental income and quarterly cash-flow distributions'
    },
    {
      id: 4,
      title: 'Secondary Market Liquidity',
      description: 'Trade tokens on approved secondary markets for liquidity when needed'
    }
  ];

  return (
    <section className="tokenization-steps-section">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">How We Do It</h2>
          <p className="section-subtitle">
            Simple 4-step process to access{'\n'}institutional real estate investments
          </p>
        </div>
        
        {/* Steps grid */}
        <div className="steps-grid">
          {steps.map((step) => (
            <div key={step.id} className="step-card">
              <div className="step-number">{step.id}</div>
              <h3 className="step-title">{step.title}</h3>
              <p className="step-description">{step.description}</p>
            </div>
          ))}
        </div>
        
        {/* CTA Button */}
        <div className="cta-container">
          <button className="cta-button" onClick={onLearnMore}>Get Started</button>
        </div>
      </div>
    </section>
  );
};

export default TokenizationSteps; 